import {fetchPrices} from '../utils/fetch-prices';
import {getPricesFromStorage, savePricesToStorage} from '../utils/local-storage';
import {isDemoMode} from '../utils/tools';

const FETCH_PRICES_ERROR = 'PriceLoad load error:';

export class PriceLoad {
    constructor() {
        this._cachePrices = getPricesFromStorage();
    }

    isLoadNeeded() {
        return !this._cachePrices || isDemoMode();
    }

    load() {
        return fetchPrices()
            .then((prices) => {
                savePricesToStorage(JSON.stringify(prices));
                return prices;
            })
            .catch((error) => {
                console.log(FETCH_PRICES_ERROR);
                console.log(error);
            });
    }

    getFromCache() {
        return JSON.parse(this._cachePrices);
    }
}
